export const APP_PATHS = {
  home: "/",
  page: "/",
  article: "/artikkel",
  products: "/boker",
  events: "/arrangementer",
  event: "/arrangementer",
  book: "/boker",
  productBundle: "/pakke",
  productList: "/boker",
  authors: "/forfattere",
  contributor: "/forfatter",
  subscription: "/abonnement",
  category: "/",
  checkout: "/utsjekk",
  receipt: "/kvittering",
  subscribe: "/innmelding",
  bookSeries: "/serie",
  literaryWork: "/verk",
  series: "/serie",
  cookieInformation: "/cookieInformation",
  "min-side": "/min-side",
} as const;
